// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/WorkTask.yaml
// Generated: 2026-02-24T18:44:19.437Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateWorkTask, UpdateWorkTask, WorkTask } from '@/types/taskmanagement/WorkTask';

/**
 * WorkTask Service
 * CRUD operations for WorkTask via the ABP API.
 */
export const workTaskService = new EntityService<WorkTask, CreateWorkTask, UpdateWorkTask>(
  '/api/taskmanagement/worktask',
  'WorkTask',
);
